import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { slug } from "@/lib/geo";

// City box that suggests towns in the chosen country while you type
export const CityInput = ({ country, value, onChange, testId, className = "" }) => {
  const [typed, setTyped] = useState(false);
  const [results, setResults] = useState([]);
  const [active, setActive] = useState(0);
  const q = value.trim();

  useEffect(() => {
    if (!typed || !country || q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      api.searchCities(country, q).then((r) => { setResults(r.slice(0, 6)); setActive(r[0]?.fuzzy ? -1 : 0); }).catch(() => setResults([]));
    }, 180);
    return () => clearTimeout(t);
  }, [q, country, typed]);

  const pick = (c) => { onChange(c.name); setTyped(false); setResults([]); };
  const onKey = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => Math.min(a + 1, results.length - 1)); }
    if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => Math.max(a - 1, -1)); }
    if (e.key === "Escape") setResults([]);
    if (e.key === "Enter" || e.keyCode === 13) { e.preventDefault(); if (results[active]) pick(results[active]); else { setResults([]); e.currentTarget.blur(); } }
  };

  return (
    <div className={`relative ${className}`}>
      <Input value={value} onChange={(e) => { setTyped(true); onChange(e.target.value); }} onKeyDown={onKey} onBlur={() => setTimeout(() => setResults([]), 150)}
        placeholder={country ? `City in ${country} (optional)` : "City (optional)"} autoComplete="off" autoCorrect="off" spellCheck={false} enterKeyHint="done" data-testid={testId} />
      {results.length > 0 && (
        <ul className="absolute z-30 left-0 right-0 mt-1 rounded-xl border border-white/10 bg-[#131A26] shadow-2xl overflow-hidden animate-pop" data-testid={`${testId}-suggestions`}>
          {results.map((c, i) => (
            <li key={`${c.name}-${c.x}-${c.y}`}>
              {c.fuzzy && !results[i - 1]?.fuzzy && <p className="px-3 pt-2 pb-1 font-mono text-[10px] uppercase tracking-[0.15em] text-sky-300/80">Did you mean</p>}
              <button type="button" onMouseDown={(e) => e.preventDefault()} onMouseEnter={() => setActive(i)} onClick={() => pick(c)} data-testid={`${testId}-option-${slug(c.name)}`}
                className={`w-full flex items-center gap-2 px-3 py-2 text-left text-xs transition-colors ${i === active ? "bg-emerald-500/15 text-emerald-200" : "text-slate-300"}`}>
                <MapPin size={12} className="shrink-0 opacity-60" />
                <span className="truncate">{c.name}{c.region && <span className="text-slate-500"> · {c.region}</span>}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
